export default {
  url: "https://scusesoapp01prd.bunzlusa.com/api/v1", // This is for DEV,
  proxyUrl: "https://ncus-prod-essproxy.azurewebsites.net/api/callEssApi?url=", // This is for Proxy server
  proxyUrlForDownload: "https://ncus-prod-essproxy.azurewebsites.net/api/download?url=", // This is for Proxy server
  proxyPost:"https://ncus-prod-essproxy.azurewebsites.net/api/loginEssPostApi"
};
